<script setup lang="ts">
import { type Customer } from "@gasparigit/omnia-sdk";
import type { FieldProps } from "../ui/auto-form";

withDefaults(
  defineProps<
    FieldProps & {
      customers: Customer[];
      custom_title?: (c: Customer) => string;
    }
  >(),
  {
    custom_title: (c: Customer) => c.name,
  }
);
</script>

<template>
  <FormField v-slot="slotProps" :name="fieldName">
    <FormItem v-bind="$attrs">
      <AutoFormLabel v-if="!config?.hideLabel" :required="required">
        {{ config?.label }}
      </AutoFormLabel>
      <FormControl>
        <Select v-bind="slotProps" :model-value="slotProps.value?.toString()" @update:model-value="(v) => slotProps.setValue(parseInt(v))">
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem v-for="customer in customers" :key="`customer-${customer.id}`" :value="`${customer.id}`">
              {{ custom_title(customer) }}
            </SelectItem>
          </SelectContent>
        </Select>
      </FormControl>
      <FormDescription v-if="config?.description">
        {{ config.description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
